export function Row({ label, children }) {
  return (
    <div className="sb-field">
      <span className="sb-label">{label}</span>
      <span className="sb-value">{children}</span>
    </div>
  );
}
